import React, { useState, useEffect, useRef } from 'react';

const services = {
  KMS: 'https://testkms.netlify.app',
  'LOG+': 'https://arjuna2.bawana.com',
};

export default function ViaIframe({ user, menuOpen = false, onCloseMenu = () => {} }) {
  const [active, setActive] = useState('LOG+');
  return (
    <div className="web-body">
      <aside id="service-sidebar" className={`web-sidebar${menuOpen ? ' is-open' : ''}`}>
        <nav aria-label="HyLearn">
          <h2>HyLearn</h2>
          {Object.keys(services).map(name => (
            <button key={name} disabled={name === 'KMS'} aria-current={active === name ? 'page' : undefined} onClick={() => { setActive(name); onCloseMenu(); }}>{name}</button>
          ))}
        </nav>
      </aside>
      <main className="web-content">
        <div className="web-content-heading"><h2>{active}</h2></div>
        <ServiceFrame key={active} name={active} origin={services[active]} user={user} />
      </main>
    </div>
  );
}

function ServiceFrame({ name, origin, user }) {
  const iframeRef = useRef(null);
  const sendIntervalRef = useRef(null);

  function stopSending() {
    clearInterval(sendIntervalRef.current);
    sendIntervalRef.current = null;
  }

  function startSending() {
    stopSending();
    let attempts = 0;
    // Keep the existing one-second retry window until the child acknowledges.
    sendIntervalRef.current = setInterval(() => {
      iframeRef.current?.contentWindow?.postMessage({
        event: 'assign_user_data',
        username: user.username,
        password_keycloak: user.pasword_keycloak,
        access_from: 'arjuna_web',
      }, origin);
      attempts += 1;
      if (attempts >= 120) stopSending();
    }, 1000);
  }

  useEffect(() => {
    function handleMessage(event) {
      if (event.origin !== origin || event.source !== iframeRef.current?.contentWindow) return;
      if (event.data?.event === 'child_recive_data') stopSending();
      if (event.data?.event === 'auto_login_done' && event.data.url) {
        try {
          const url = new URL(event.data.url);
          if (url.protocol === 'https:' || url.protocol === 'http:') {
            window.open(url.href, event.data.target || '_blank');
          }
        } catch { /* Ignore malformed callback URLs. */ }
      }
    }
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      stopSending();
    };
  }, [origin]);

  return <iframe ref={iframeRef} id="iframeTarget" className="service-frame" allow="web-share; clipboard-write" title={`${name} iframe`} src={`${origin}/arjuna-callback-via-iframe/`} onLoad={startSending} />;
}
